import Assignee from 'models/assignee';
import { createContentModel, isEmpty } from './composition_content_shared';
import { CustomAttributeValue } from 'models/custom_attribute';
import { prop } from 'models/lib/create_model';

const TaskCompositionContent = createContentModel({
  modelName: 'TaskCompositionContent',

  properties: {
    assignee: Assignee,
    bodyHtml: String,
    customAttributes: prop([CustomAttributeValue]).default([]),
    dueAt: String,
    topicIds: prop([String]).default([]),
  },

  // Topics and attributes don't count toward emptiness — a draft with only
  // topics is still an empty task, and would otherwise block the discard prompt.
  isEmpty() {
    return isEmpty(this.bodyHtml);
  },
});

TaskCompositionContent.MAX_SINGLE_ATTACHMENT_SIZE_MB = 500;
TaskCompositionContent.MAX_TOTAL_ATTACHMENT_SIZE_MB = 1000;

export default TaskCompositionContent;
